import { render } from "./AccountToggle.vue?vue&type=template&id=a9dd1772&scoped=true"
import script from "./AccountToggle.vue?vue&type=script&lang=js"
export * from "./AccountToggle.vue?vue&type=script&lang=js"

import "./AccountToggle.vue?vue&type=style&index=0&id=a9dd1772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9dd1772"]])

export default __exports__